<button class="close" mat-button (click)="onNoClick()">X</button>

<ng-container>
  <div class="container aviso" *ngIf="!loading && ventaPausadaInfo">
    <div class="tituloSearch row">{{ 'NUMERO_OPERACION' | translate }}</div>
    <div class="row font-weight-bold text-centro subtitulo-dialog">
      {{ ventaPausadaInfo.identificador || '-' }}
    </div>
    <div class="row font-weight-bold text-centro subtitulo-dialog">
      {{ ventaPausadaInfo.tag || '-' }}
    </div>
    <ng-container *ngIf="showForm">
      <section class="enLocalizador" style="margin: 20px 0;">
        <div
          class="Rtable"
        >
          <div class="Rtable-row Rtable-row--head">
            <div class="Rtable-cell column-heading cell-ventapausada">
              {{ 'ITEM' | translateV2 }}
            </div>
            <div class="Rtable-cell column-heading cell-ventapausada">
              {{ 'CANTIDAD' | translateV2 }}
            </div>
            <div class="Rtable-cell column-heading cell-ventapausada">
              {{ 'TOTAL' | translateV2 }}
            </div>
            <!-- <div class="Rtable-cell column-heading cell-ventapausada">
              {{ 'ACCIONES' | translateV2 }}
            </div> -->
          </div>
  
          <div class="listado" id="entradas">
            <!-- VISITAS LIST -->
            <div
              class="Rtable-row"
              *ngFor="let albaranItem of albaranItems"
            >
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ albaranItem?.tarifaDisponible?.NombrePantalla || '-' }}
                </div>
              </div>
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ albaranItem?.cantidad || '-' }}
                </div>
              </div>
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ getPrecioTotalPorItem(albaranItem) | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}
                </div>
              </div>
              <!-- <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  "ACCION"
                </div>
              </div> -->
            </div>

            <!-- TIENDA - RESTAURACION LIST -->
            <div
              class="Rtable-row"
              *ngFor="let tiendaRestItem of tiendaRestItems"
            >
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ tiendaRestItem?.entrada?.NombrePantalla || '-' }}
                </div>
              </div>
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ tiendaRestItem?.cantidad || '-' }}
                </div>
              </div>
              <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  {{ getPrecioTotalPorItem(tiendaRestItem) | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}
                </div>
              </div>
              <!-- <div class="Rtable-cell cell-ventapausada">
                <div class="Rtable-cell--content custom-cell">
                  "ACCION"
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </section>
    </ng-container>

    <div class="container avisoInputWrap mt-3">
      <div class="faturacion-fila row">
        <div class="dialog-bottomside-info text-dialog">
          <div>{{ 'PRODUCTOS' | translateV2 }}</div>
          <div>
            <span class="total">
              {{ getCantidadDeItems() || 0 }}
            </span>
          </div>
        </div>
        <div class="dialog-bottomside-info text-dialog">
          <div>
            {{ 'TOTAL' | translateV2 }}
          </div>
          <div>
            <span class="total">
              {{ getPrecioFinalTotal() | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion : divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles }}
            </span>
          </div>
        </div>
      </div>
      <div class="faturacion-fila row">
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button
              type="button"
              value="eliminar"
              class="cancelar"
              (click)="eliminar()"
            >
              {{ 'ELIMINAR' | translate }}
            </button>
          </div>
        </div>
        <div class="ticket-info col-6">
          <div class="inputControl botones">
            <button type="button" (click)="continuar()" class="pagar aceptar">
              {{ 'CONTINUAR' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template *ngIf="loading">
    <div class="DetalleBox__noResultsMessage">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </ng-template>
</ng-container>
